/**
 * Initial POI taxonomy data.
 *
 * v1 starts with an empty taxonomy set; users manage entries via Operations UI.
 */
const initialPoiTaxonomiesData = [];

export default initialPoiTaxonomiesData;
